import {useListView} from '../../core/ListViewProvider'
import {MHCListToolbar} from './MHCListToolbar'
import {SitesListGrouping} from './SitesListGrouping'

const MHCListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
   
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        <MHCListToolbar />
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {MHCListHeader}
